export const brandColors = {
    primary: '#4C956C',      // fresh green - main brand color
    secondary: '#6DAF85',    // avocado soft green - accent secondary
    background: '#F9F7F3',   // light cream - ideal site background
    accent: '#A3D9A5',       // mint highlight
    accentDark: '#2F3E46',   // deep olive - great for sidebar or dark elements

    // dark (new)
    darkBackground: "#121614",      // app background
    darkPaper: "#1A211E",           // cards/surfaces
    darkText: "#F1F5F3",            // main text
    darkMutedText: "#B9C4BF",       // secondary text
    darkAccent: "#2B6A4B",          // darker mint/green accent
} as const;


